module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-snackbar', {
    attrs: {
      "color": "success",
      "multi-line": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "variant": "text"
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, [_vm._v("\n        Close\n      ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarMessage) + "\n    ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.customerList,
      "label": "Select a Customer",
      "item-text": "name",
      "item-value": "key",
      "clearable": "",
      "prepend-icon": "refresh"
    },
    on: {
      "click:prepend": _vm.refreshData
    },
    model: {
      value: (_vm.activeCustomer),
      callback: function($$v) {
        _vm.activeCustomer = $$v
      },
      expression: "activeCustomer"
    }
  })], 1)], 1), _vm._v(" "), (_vm.activeCustomer === null) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("OR")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "block": "",
      "to": "/Admin/Customer"
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add New Customer\n      ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.projectSummaryCards), function(card, i) {
    return (_vm.projectStates[i] > 0) ? _c('v-flex', {
      key: i
    }, [_c('v-card', {
      staticClass: "pa-2 ma-1 text-xs-center"
    }, [(i < 5 || _vm.includeArchive === true) ? _c('v-progress-circular', {
      attrs: {
        "size": 70,
        "width": 10,
        "rotate": 360,
        "value": (_vm.projectStates[i] / _vm.totalProjects) * 100,
        "color": card.color
      }
    }, [_vm._v("\n          " + _vm._s(_vm.projectStates[i]) + "\n        ")]) : _c('v-btn', {
      staticClass: "my-3",
      attrs: {
        "round": "",
        "color": card.color,
        "dark": ""
      },
      on: {
        "click": _vm.getArchive
      }
    }, [_vm._v("Load Complete Projects")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(card.title))])], 1)], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2 mb-3"
  }, [_c('v-card-title', [_c('v-dialog', {
    attrs: {
      "max-width": "90%",
      "persistent": ""
    },
    model: {
      value: (_vm.projectDialog),
      callback: function($$v) {
        _vm.projectDialog = $$v
      },
      expression: "projectDialog"
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeCustomer),
      expression: "activeCustomer"
    }],
    staticClass: "mb-2",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.getNewProjectId
    },
    slot: "activator"
  }, [_vm._v("New Project")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "mb-0 pb-0"
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.projectFormTitle))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Send booking email(s)",
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "browser-autocomplete": "new-email",
      "success-messages": _vm.emailSuccess,
      "error-messages": _vm.emailError
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-fade-transition', {
          attrs: {
            "leave-absolute": ""
          }
        }, [(_vm.sendingEmail) ? _c('v-progress-circular', {
          attrs: {
            "size": "24",
            "color": "primary",
            "indeterminate": ""
          }
        }) : _c('v-btn', {
          attrs: {
            "disabled": _vm.bookingEmailAddress.length < 1,
            "color": "primary",
            "flat": "",
            "icon": ""
          },
          on: {
            "click": _vm.sendBookingEmail
          }
        }, [_c('v-icon', [_vm._v("send")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.bookingEmailAddress),
      callback: function($$v) {
        _vm.bookingEmailAddress = $$v
      },
      expression: "bookingEmailAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.gettingNewProjectId) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": "50"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.saveProjectFailed),
      callback: function($$v) {
        _vm.saveProjectFailed = $$v
      },
      expression: "saveProjectFailed"
    }
  }, [_vm._v("An error occured when trying to save the project. Please\n                    try again.")]), _vm._v(" "), _c('v-form', {
    ref: "newProjectForm",
    model: {
      value: (_vm.newProjectValid),
      callback: function($$v) {
        _vm.newProjectValid = $$v
      },
      expression: "newProjectValid"
    }
  }, [_c('v-subheader', [_vm._v("General")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "readonly": "",
      "label": "Project ID"
    },
    model: {
      value: (_vm.editedProject.projectId),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "projectId", $$v)
      },
      expression: "editedProject.projectId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Created Date",
      "value": _vm._f("formatDate")(_vm.editedProject.CreatedDate),
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "box": "",
      "label": "Priority",
      "item-text": "text",
      "item-value": "value",
      "items": [{
          text: 'High',
          value: 1
        },
        {
          text: 'Medium',
          value: 2
        },
        {
          text: 'Low',
          value: 3
        } ]
    },
    model: {
      value: (_vm.editedProject.priority),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "priority", $$v)
      },
      expression: "editedProject.priority"
    }
  })], 1), _vm._v(" "), (_vm.userData.Role === 'Admin') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Priority Number"
    },
    model: {
      value: (_vm.editedProject.priorityOrder),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "priorityOrder", $$v)
      },
      expression: "editedProject.priorityOrder"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Job Type",
      "items": ['Order', 'Service Call']
    },
    model: {
      value: (_vm.editedProject.jobType),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "jobType", $$v)
      },
      expression: "editedProject.jobType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Project Status",
      "items": [
        'CTN Sheet Approved',
        'In Progress',
        'In Progress HW setup',
        'In Progress Shipped',
        'Install In Progress',
        'Complete',
        'Cancelled',
        'In Query' ],
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.Status),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "Status", $$v)
      },
      expression: "editedProject.Status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "multiple": "",
      "required": "",
      "label": "Project Manager(s)",
      "rules": [function (v) { return !!v || 'Item is required'; }],
      "item-value": "Name",
      "item-text": "Name",
      "items": _vm.projectManagers
    },
    model: {
      value: (_vm.editedProject.manager),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "manager", $$v)
      },
      expression: "editedProject.manager"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Allowed Marketing Stickers",
      "items": ['Yes', 'No']
    },
    model: {
      value: (_vm.editedProject.marketingStickers),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "marketingStickers", $$v)
      },
      expression: "editedProject.marketingStickers"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Supplier")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Assign to Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key",
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.Supplier),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "Supplier", $$v)
      },
      expression: "editedProject.Supplier"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "type": "number",
      "label": "Supplier Cost",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.supplierCost),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "supplierCost", $$v)
      },
      expression: "editedProject.supplierCost"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Zendesk")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Zendesk - Customer Ticket"
    },
    model: {
      value: (_vm.editedProject.customerTicket),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "customerTicket", $$v)
      },
      expression: "editedProject.customerTicket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Zendesk - BDM Order Ticket"
    },
    model: {
      value: (_vm.editedProject.BDMTicket),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "BDMTicket", $$v)
      },
      expression: "editedProject.BDMTicket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Zendesk - Engineer Ticket"
    },
    model: {
      value: (_vm.editedProject.engineerTicket),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "engineerTicket", $$v)
      },
      expression: "editedProject.engineerTicket"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Finance - Customer")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Finance Status - Customer",
      "items": [
        'Not Started',
        'Invoiced',
        'No Costs to Invoice',
        'Query' ],
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.financeCustomer),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "financeCustomer", $$v)
      },
      expression: "editedProject.financeCustomer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Finance - Customer Invoiced",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.financeInvoiced),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "financeInvoiced", $$v)
      },
      expression: "editedProject.financeInvoiced"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Customer PO Number"
    },
    model: {
      value: (_vm.editedProject.customerPO),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "customerPO", $$v)
      },
      expression: "editedProject.customerPO"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [(_vm.editedProject.jobType === 'Service Call') ? _c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Customer Cost",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.customerCost),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "customerCost", $$v)
      },
      expression: "editedProject.customerCost"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Finance - Supplier")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "box": "",
      "label": "Finance Status - Supplier",
      "items": [
        'Not Started',
        'In Query',
        'Supplier part Paid',
        'Complete - Supplier Paid',
        'Complete - No Cost' ],
      "clearable": ""
    },
    model: {
      value: (_vm.editedProject.financeSupplier),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "financeSupplier", $$v)
      },
      expression: "editedProject.financeSupplier"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Supplier Amount Paid",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.editedProject.supplierPaid),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "supplierPaid", $$v)
      },
      expression: "editedProject.supplierPaid"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Supplier Invoice Numbers"
    },
    model: {
      value: (_vm.editedProject.supplierInvoiceNumbers),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "supplierInvoiceNumbers", $$v)
      },
      expression: "editedProject.supplierInvoiceNumbers"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Notes"
    },
    model: {
      value: (_vm.editedProject.notes),
      callback: function($$v) {
        _vm.$set(_vm.editedProject, "notes", $$v)
      },
      expression: "editedProject.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('upload-btn', {
    attrs: {
      "uniqueId": "",
      "title": 'Attach New Document',
      "multiple": true,
      "fileChangedCallback": _vm.attachFile
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-paperclip")])], 1)], 2), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.fileProgress === 100 ? 'success' : 'primary',
      "value": _vm.fileProgress
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "mt-3",
    attrs: {
      "avatar": ""
    }
  }, _vm._l((_vm.editedProject.attachedDocs), function(doc, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "href": doc.downloadUrl,
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(doc.name))])])], 1), _vm._v(" "), (
      _vm.userData.UID === 'KmPhBoqfuxcqM2Vu6ES1JHx0Yzd2' ||
      _vm.userData.UID === 'XPq26H0FBcYICFHg6JbUvfVC2fn2' ||
      _vm.userData.UID === 'b8yNX9oGK8UcntezqIupoXt8BBl2' ||
      _vm.userData.UID === 'HxvYXLfcVVc2LuVW55Wv9b9EZOk1'
    ) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(doc)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e()], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteProjectModal(_vm.editedProject)
      }
    }
  }, [_vm._v("Delete Project")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeProject($event)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "disabled": !_vm.newProjectValid,
      "loading": _vm.savingSaveProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveProject(true)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Filter by Status",
      "items": _vm.projectSummaryCards,
      "item-value": "title",
      "item-text": "title",
      "multiple": "",
      "clearable": "",
      "single-line": "",
      "hide-details": "",
      "chips": ""
    },
    model: {
      value: (_vm.projectStatusFilter),
      callback: function($$v) {
        _vm.projectStatusFilter = $$v
      },
      expression: "projectStatusFilter"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Filter by Type",
      "items": [{
          value: '0',
          title: 'All Types'
        },
        {
          value: 'sc',
          title: 'Service Calls'
        },
        {
          value: 'p',
          title: 'Project'
        } ],
      "item-value": "value",
      "item-text": "title",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.projectTypeFilter),
      callback: function($$v) {
        _vm.projectTypeFilter = $$v
      },
      expression: "projectTypeFilter"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Project Manager Filter",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.activeManager),
      callback: function($$v) {
        _vm.activeManager = $$v
      },
      expression: "activeManager"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchProject),
      callback: function($$v) {
        _vm.searchProject = $$v
      },
      expression: "searchProject"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "rows-per-page-items": [
        25,
        50,
        100,
        {
          text: '$vuetify.dataIterator.rowsPerPageAll',
          value: -1
        } ],
      "headers": _vm.projectHeaders,
      "items": _vm.filteredProjects,
      "search": _vm.searchProject,
      "item-key": "id",
      "loading": _vm.projectTableLoading,
      "pagination": _vm.projectsPagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.projectsPagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.priority === 1 ? 'red lighten-4' : ''
        }, [_c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              if (_vm.activeCustomer === props.item.Customer) {
                props.expanded = !props.expanded;
                _vm.customerToRetrieve = props.item.Customer;
              } else {
                _vm.openProject(props.item);
              }
            }
          }
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.activeCustomer === null),
            expression: "activeCustomer === null"
          }]
        }, [_vm._v(_vm._s(props.item.projectId) + "\n              "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-open-in-new")])], 1), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.activeCustomer !== null),
            expression: "activeCustomer !== null"
          }]
        }, [_vm._v(_vm._s(props.item.projectId))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.qnq))]), _vm._v(" "), (_vm.activeCustomer === null) ? _c('td', [_c('a', {
          on: {
            "click": function($event) {
              _vm.activeCustomer = props.item.Customer
            }
          }
        }, [_vm._v(_vm._s(_vm.customerNameFromID(props.item.Customer)))])]) : _vm._e(), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.customerToRetrieve = props.item.Customer;
            }
          }
        }, [(props.item.CreatedDate == _vm.today) ? _c('v-chip', {
          attrs: {
            "color": "green",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("New")]) : _vm._e(), _vm._v(_vm._s(_vm._f("formatDate")(props.item.CreatedDate)) + "\n          ")], 1), _vm._v(" "), (_vm.activeCustomer === null) ? _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.customerToRetrieve = props.item.Customer;
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.BDM) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.activeCustomer !== null) ? _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.customerToRetrieve = props.item.Customer;
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.supplierNameFromID(props.item.Supplier)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.customerToRetrieve = props.item.Customer;
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.Status ? props.item.Status : "Awaiting Approval") + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.customerToRetrieve = props.item.Customer;
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.manager) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.customerToRetrieve = props.item.Customer;
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.priorityText) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded;
              _vm.customerToRetrieve = props.item.Customer;
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.priorityOrder) + "\n          ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editProject(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteProjectModal(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, _vm._l((_vm.projectSummary(props.item.projectId)), function(summary, i) {
          return _c('div', {
            key: i
          }, [_c('v-chip', {
            attrs: {
              "dark": ""
            }
          }, [_c('v-avatar', {
            staticClass: "primary"
          }, [_vm._v(_vm._s(summary))]), _vm._v("\n              " + _vm._s(_vm.templates.find(function (t) {
            return t.id === i;
          }).name) + "\n            ")], 1)], 1)
        }), 0), _vm._v(" "), _c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs8": ""
          }
        }, [_c('v-card', {
          staticClass: "ma-2 elevation-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-list', {
          attrs: {
            "dark": "",
            "dense": ""
          }
        }, [_c('v-list-tile', [_c('v-layout', [_c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v(" Status ")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v(" Vehicle ")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v(" Date ")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs3": ""
          }
        }, [_c('v-list-tile-content', [_vm._v(" Job Number ")])], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.expandedJobs(props.item.projectId)), function(job, i) {
          return [_c('v-list-tile', {
            key: i,
            on: {
              "click": function($event) {
                return _vm.expandProjectJob(job)
              }
            }
          }, [_c('v-layout', [_c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', {
            attrs: {
              "color": job.Status >= 2 ?
                'green' :
                job.Status === 1 ?
                'red' :
                job.Supplier === '' || job.Supplier === null ?
                'grey' :
                job.Allocated === '' ||
                job.Allocated === null ?
                'cyan' :
                'orange'
            }
          }, [_vm._v("assignment")])], 1)], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-content', [_vm._v("\n                          " + _vm._s(_vm._f("uppercase")((job.Vehicle ?
            _vm.vehicleRegFromID(job.Vehicle) :
            job.vehReg))) + "\n                        ")])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-content', [_vm._v("\n                          " + _vm._s(_vm._f("formatDate")(job.Date)) + "\n                        ")])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs3": ""
            }
          }, [_c('v-list-tile-content', [_vm._v("\n                          " + _vm._s(job.JobNo) + "\n                        ")])], 1)], 1)], 1), _vm._v(" "), _vm._l((job.templates), function(product) {
            return (job === _vm.expandedProjectJob) ? _c('v-list-tile', {
              key: product
            }, [_c('v-layout', [_c('v-flex', {
              attrs: {
                "xs12": ""
              }
            }, [_c('v-list-tile-content', [_vm._v("\n                          " + _vm._s(_vm.templates.find(function (t) {
              return t.id === product;
            }).name) + "\n                        ")])], 1)], 1)], 1) : _vm._e()
          })]
        })], 2)], 1)], 1)], 1), _vm._v(" "), (props.item.attachedDocs && props.item.attachedDocs.length > 0) ? _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-card', {
          staticClass: "my-2 pa-2 elevation-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-list', {
          staticClass: "mt-3",
          attrs: {
            "avatar": ""
          }
        }, [_c('h5', {
          staticClass: "title"
        }, [_vm._v("Attached Documents")]), _vm._v(" "), _vm._l((props.item.attachedDocs), function(doc) {
          return _c('v-list-tile', {
            key: doc.name
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
            attrs: {
              "href": doc.downloadUrl,
              "target": "_BLANK"
            }
          }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
        })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (props.item.contacts && props.item.contacts.length > 0) ? _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-card', {
          staticClass: "my-2 pa-2 elevation-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('h5', {
          staticClass: "title"
        }, [_vm._v("Contacts")]), _vm._v(" "), _c('v-data-table', {
          attrs: {
            "items": _vm.contacts,
            "hide-actions": "",
            "headers": [{
                text: 'Name',
                value: 'Name'
              },
              {
                text: 'Email',
                value: 'EmailAddress'
              },
              {
                text: 'Phone',
                value: 'Phone'
              },
              {
                text: 'Mobile',
                value: 'Mobile'
              },
              {
                text: 'Type',
                value: 'Type',
                sortable: false
              } ]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props1) {
              return [(props.item.contacts.indexOf(props1.item.key) !== -1) ? _c('tr', [_c('td', [_vm._v(_vm._s(props1.item.Name))]), _vm._v(" "), _c('td', [_c('a', {
                attrs: {
                  "href": 'mailto:' + props1.item.EmailAddress
                }
              }, [_vm._v(_vm._s(props1.item.EmailAddress))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props1.item.Phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props1.item.Mobile))]), _vm._v(" "), _c('td', [(props1.item.Fleet) ? _c('v-tooltip', {
                attrs: {
                  "bottom": ""
                }
              }, [_c('v-chip', {
                attrs: {
                  "slot": "activator",
                  "small": ""
                },
                slot: "activator"
              }, [_c('v-icon', [_vm._v("mdi-truck")])], 1), _vm._v(" "), _c('span', [_vm._v("Fleet")])], 1) : _vm._e(), _vm._v(" "), (props1.item.Comms) ? _c('v-tooltip', {
                attrs: {
                  "bottom": ""
                }
              }, [_c('v-chip', {
                attrs: {
                  "slot": "activator",
                  "small": ""
                },
                slot: "activator"
              }, [_c('v-icon', [_vm._v("mdi-phone")])], 1), _vm._v(" "), _c('span', [_vm._v("Comms")])], 1) : _vm._e(), _vm._v(" "), (props1.item.Accounts) ? _c('v-tooltip', {
                attrs: {
                  "bottom": ""
                }
              }, [_c('v-chip', {
                attrs: {
                  "slot": "activator",
                  "small": ""
                },
                slot: "activator"
              }, [_c('v-icon', [_vm._v("mdi-cash-100")])], 1), _vm._v(" "), _c('span', [_vm._v("Accounts")])], 1) : _vm._e()], 1)]) : _vm._e()]
            }
          }], null, true)
        })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (props.item.notes) ? _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-card', {
          staticClass: "my-2 pa-2 elevation-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('h5', {
          staticClass: "title"
        }, [_c('v-icon', [_vm._v("speaker_notes")]), _vm._v(" Notes")], 1), _vm._v(" "), _c('v-textarea', {
          attrs: {
            "readonly": "",
            "solo": "",
            "flat": ""
          },
          model: {
            value: (props.item.notes),
            callback: function($$v) {
              _vm.$set(props.item, "notes", $$v)
            },
            expression: "props.item.notes"
          }
        })], 1)], 1)], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.activeCustomer !== null) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.summaryCards), function(card, i) {
    return _c('v-flex', {
      key: i
    }, [_c('v-card', {
      staticClass: "pa-2 ma-1 text-xs-center"
    }, [_c('v-progress-circular', {
      attrs: {
        "size": 70,
        "width": 10,
        "rotate": 360,
        "value": (_vm.states[i] / _vm.totalJobs) * 100,
        "color": card.color
      }
    }, [_vm._v("\n          " + _vm._s(_vm.states[i]) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(card.title))])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.activeCustomer !== null) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.copyJobsData
    }
  }, [_c('v-icon', [_vm._v("mdi-content-copy")]), _vm._v(" Copy Data")], 1), _vm._v(" "), _c('bulk-import-export-dialog', {
    attrs: {
      "parentCustomer": _vm.activeCustomer
    },
    on: {
      "jobsUpdated": _vm.getJobs,
      "updatingVehicleReg": _vm.updatedVehicleReg
    }
  }), _vm._v(" "), _c('merge-jobs-dialog', {
    attrs: {
      "openDialog": _vm.mergeJobsDialog,
      "jobs": _vm.selected,
      "mergeJobsDialog": _vm.mergeJobsDialog
    },
    on: {
      "update:mergeJobsDialog": function($event) {
        _vm.mergeJobsDialog = $event
      },
      "update:merge-jobs-dialog": function($event) {
        _vm.mergeJobsDialog = $event
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "90%",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("New Job")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formTitle))])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "info",
      "value": _vm.editedItem.Status > 1
    }
  }, [_vm._v("This job has already been completed, please only edit the\n                    job if details were incorrect at time of install.")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error",
      "dismissible": ""
    },
    model: {
      value: (_vm.saveJobFailed),
      callback: function($$v) {
        _vm.saveJobFailed = $$v
      },
      expression: "saveJobFailed"
    }
  }, [_vm._v("An error occured when trying to save the job. Please try\n                    again.")]), _vm._v(" "), _c('v-form', {
    ref: "newJob",
    model: {
      value: (_vm.newJobValid),
      callback: function($$v) {
        _vm.newJobValid = $$v
      },
      expression: "newJobValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "notes",
      "outline": ""
    },
    model: {
      value: (_vm.editedItem.notes),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "notes", $$v)
      },
      expression: "editedItem.notes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Vehicle",
      "items": _vm.vehicles,
      "loading": _vm.gettingVehicles,
      "item-value": "VehicleReg",
      "item-text": "VehicleReg",
      "rules": [function (v) { return !!v || 'Item is required'; }],
      "required": "",
      "clearable": ""
    },
    model: {
      value: (_vm.vehicleSelect),
      callback: function($$v) {
        _vm.vehicleSelect = $$v
      },
      expression: "vehicleSelect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "label": "Select Customer",
      "items": _vm.customerList,
      "item-text": "name",
      "item-value": "key",
      "dense": ""
    },
    model: {
      value: (_vm.editedItem.Customer),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Customer", $$v)
      },
      expression: "editedItem.Customer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Select Site",
      "readonly": "",
      "items": _vm.sites,
      "item-text": "Name",
      "item-value": "key",
      "hint": "What site is this vehicle at?",
      "dense": ""
    },
    model: {
      value: (_vm.editedItem.VehicleSite),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "VehicleSite", $$v)
      },
      expression: "editedItem.VehicleSite"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "rules": [function (v) { return !!v || 'Item is required'; }],
      "required": "",
      "label": "Select Products",
      "items": _vm.products,
      "multiple": "",
      "chips": "",
      "item-text": "name",
      "item-value": "id",
      "hint": "What products does this job need?",
      "persistent-hint": "",
      "deletable-chips": "",
      "dense": ""
    },
    model: {
      value: (_vm.selectProducts),
      callback: function($$v) {
        _vm.selectProducts = $$v
      },
      expression: "selectProducts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Assign to Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.supplierSelect),
      callback: function($$v) {
        _vm.supplierSelect = $$v
      },
      expression: "supplierSelect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Assign to Engineer",
      "items": _vm.supplierSelectEngineers,
      "item-text": "name",
      "item-value": "key",
      "loading": _vm.gettingEngineers,
      "clearable": ""
    },
    model: {
      value: (_vm.editedItem.Allocated),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Allocated", $$v)
      },
      expression: "editedItem.Allocated"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "rules": [function (v) { return !!v || 'Item is required'; }],
      "required": "",
      "label": "Assign to Project",
      "items": _vm.filteredCustomerProjectsByEditedCustomer,
      "item-text": "projectId",
      "item-value": "projectId",
      "clearable": ""
    },
    on: {
      "change": _vm.setJobSupplier
    },
    model: {
      value: (_vm.editedItem.Project),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Project", $$v)
      },
      expression: "editedItem.Project"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-menu', {
    ref: "dateDialog",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "min-width": "290px",
      "return-value": _vm.editedItem.Date,
      "close-on-content-click": false
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.editedItem, "Date", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.editedItem, "Date", $event)
      }
    },
    model: {
      value: (_vm.dateDialog),
      callback: function($$v) {
        _vm.dateDialog = $$v
      },
      expression: "dateDialog"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Install Date",
      "value": _vm._f("formatDate")(_vm.editedItem.Date),
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.dateDialog.save(_vm.editedItem.Date)
      }
    },
    model: {
      value: (_vm.editedItem.Date),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Date", $$v)
      },
      expression: "editedItem.Date"
    }
  })], 1)], 1), _vm._v(" "), (_vm.oldExtras) ? [_vm._l((_vm.editedItem.extras), function(item, index) {
    return [(item.length) ? _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "text",
        "label": index
      },
      model: {
        value: (_vm.editedItem.extras[index]),
        callback: function($$v) {
          _vm.$set(_vm.editedItem.extras, index, $$v)
        },
        expression: "editedItem.extras[index]"
      }
    })], 1) : _vm._e()]
  })] : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.oldExtras = true
      }
    }
  }, [_vm._v("Show Old Extras")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.editedItem.additionalFields), function(field, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "md2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Field Name"
      },
      model: {
        value: (field['fieldName']),
        callback: function($$v) {
          _vm.$set(field, 'fieldName', $$v)
        },
        expression: "field['fieldName']"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs7": "",
        "md4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Field Value"
      },
      model: {
        value: (field['fieldValue']),
        callback: function($$v) {
          _vm.$set(field, 'fieldValue', $$v)
        },
        expression: "field['fieldValue']"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "flat": "",
        "icon": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editedItem.additionalFields.splice(index, 1)
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    ref: "additionalFieldBtn",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.addAdditionalField
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("add")]), _vm._v("Additional Field")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._l((_vm.editedItem.templateExtras), function(product) {
    return [_c('h4', {
      key: product.id
    }, [_vm._v("\n                            Product: " + _vm._s(product.product.name) + "\n                          ")]), _vm._v(" "), _c('v-layout', {
      key: product.id,
      attrs: {
        "wrap": "",
        "row": ""
      }
    }, [_vm._l((_vm.productExtras.filter(
      function (p) { return p.id === product.product.id; }
    )), function(item, index) {
      return [(_vm.editedItem.extras[product.product.id]) ? _c('v-flex', {
        key: index,
        attrs: {
          "xs12": "",
          "sm6": "",
          "md4": ""
        }
      }, [(item.type === 'choice') ? _c('v-select', {
        attrs: {
          "label": item.name,
          "items": item.options,
          "required": item.required === true,
          "clearable": item.default === '' ? true : false
        },
        model: {
          value: (
            _vm.editedItem.extras[product.product.id][
              item.name
            ]
          ),
          callback: function($$v) {
            _vm.$set(_vm.editedItem.extras[product.product.id],
              item.name, $$v)
          },
          expression: "\n                                    editedItem.extras[product.product.id][\n                                      item.name\n                                    ]\n                                  "
        }
      }) : (item.type === 'text') ? _c('v-text-field', {
        attrs: {
          "type": "text",
          "label": item.name,
          "required": item.required === true
        },
        model: {
          value: (
            _vm.editedItem.extras[product.product.id][
              item.name
            ]
          ),
          callback: function($$v) {
            _vm.$set(_vm.editedItem.extras[product.product.id],
              item.name, $$v)
          },
          expression: "\n                                    editedItem.extras[product.product.id][\n                                      item.name\n                                    ]\n                                  "
        }
      }) : _c('v-text-field', {
        attrs: {
          "type": "number",
          "step": item.step,
          "label": item.name,
          "required": item.required === true
        },
        model: {
          value: (
            _vm.editedItem.extras[product.product.id][
              item.name
            ]
          ),
          callback: function($$v) {
            _vm.$set(_vm.editedItem.extras[product.product.id],
              item.name, $$v)
          },
          expression: "\n                                    editedItem.extras[product.product.id][\n                                      item.name\n                                    ]\n                                  "
        }
      })], 1) : _vm._e()]
    })], 2), _vm._v(" "), _vm._l((product.templateDetails), function(device) {
      return [(device.extras !== undefined) ? [_c('v-card', {
        key: device.id
      }, [_c('h5', [_vm._v("Device: " + _vm._s(device.name))]), _vm._v(" "), (device.deviceDetails) ? _c('table', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('thead', _vm._l((device.extras), function(detail) {
        return _c('th', {
          key: detail.id
        }, [_vm._v("\n                                      " + _vm._s(detail.name) + "\n                                    ")])
      }), 0), _vm._v(" "), _c('tbody', _vm._l((device.extras), function(detail) {
        return _c('td', {
          key: detail.id,
          staticClass: "pa-2 text-sm-center"
        }, [_c('span', [_vm._v(_vm._s(device.deviceDetails[detail.name]))])])
      }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((device.extras), function(detail) {
        return [(
          detail.type === 'uid' &&
          !device.deviceDetails
        ) ? _c('v-autocomplete', {
          key: detail.name,
          staticClass: "mx-4 mt-2",
          attrs: {
            "box": "",
            "label": "Select Device",
            "append-outer-icon": "refresh",
            "item-value": "id",
            "return-object": "",
            "item-text": "id",
            "items": _vm.devices.filter(
              function (d) { return d.type === device.id && !d.vehicle; }
            ),
            "value": device.deviceDetails !== undefined ?
              device.deviceDetails[detail.name] :
              ''
          },
          on: {
            "change": function (v) {
              device.deviceDetails = v;
            },
            "click:append-outer": _vm.forceUpdate
          }
        }) : _vm._e()]
      })], 2)] : _vm._e()]
    })]
  })], 2)], 2)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "disabled": !_vm.newJobValid,
      "loading": _vm.savingSaveJob
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Filter by Status",
      "items": _vm.Statuses,
      "item-value": "value",
      "item-text": "text",
      "multiple": "",
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    ref: "jobsTable",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredJobs,
      "search": _vm.search,
      "item-key": "id",
      "select-all": "",
      "loading": _vm.tableLoading,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-edit-dialog', {
          attrs: {
            "return-value": _vm.updateRegV,
            "lazy": "",
            "large": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.updateRegV = $event
            },
            "update:return-value": function($event) {
              _vm.updateRegV = $event
            },
            "save": function($event) {
              return _vm.updateReg(props.item)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "value": props.item.Vehicle
                },
                on: {
                  "change": function (v) { return (_vm.updateRegV = v); }
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1), _vm._v("\n                " + _vm._s(props.item.Vehicle) + "\n              ")], 1)])], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.VehicleMake) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.VehicleModel) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.VehicleYear) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("formatDate")(props.item.CompletedDate)) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.Engineer) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.currency || "£") + _vm._s(props.item.cost || 0) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.Project) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.JobNo) + "\n          ")]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("jobStatus")(props.item.Status, props.item.Allocated)) + "\n          ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [(props.item.jobStarted && props.item.Status == 0) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "blue"
                }
              }, [_vm._v("account_box")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Engineer has started this job but not sent it back to portal\n                yet")])]) : _vm._e(), _vm._v(" "), (props.item.Status > 0) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.viewJob(props.item.id)
            }
          }
        }, [(props.item.Status > 2) ? _c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("assignment_turned_in")]) : (props.item.Status == 2) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("assignment_ind")]) : _c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("assignment_late")])], 1) : _vm._e(), _vm._v(" "), (props.item.chargeable) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "black"
          }
        }, [_vm._v("mdi-currency-gbp")])], 1) : _vm._e(), _vm._v(" "), (props.item.Status < 3) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.approveJob(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editItem(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteItem(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [_c('v-card', {
          staticClass: "ma-2"
        }, [_vm._v("\n            " + _vm._s(_vm.mergePropsNotes(props.item.notes, props.item.Notes)) + "\n            "), _c('v-list', {
          attrs: {
            "dark": "",
            "dense": ""
          }
        }, _vm._l((props.item.templates), function(template, i) {
          return _c('v-list-tile', {
            key: i
          }, [_c('v-list-tile-action', [_c('v-checkbox', {
            attrs: {
              "disabled": "",
              "input-value": "true"
            }
          })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.templates.find(function (t) {
            return t.id === template;
          }).name))])], 1)], 1)
        }), 1)], 1)], 1)]
      }
    }], null, false, 2479366546),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('completed-view', {
    attrs: {
      "visible": _vm.viewDialog,
      "JobID": _vm.currentJob
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDialog = $event
      },
      "approveJob": _vm.approveJob,
      "issueJob": _vm.issueJob
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "750px",
      "scrollable": ""
    },
    model: {
      value: (_vm.deleteProjectDialog),
      callback: function($$v) {
        _vm.deleteProjectDialog = $$v
      },
      expression: "deleteProjectDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Delete Project")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Please confirm whether you would also like to delete the related jobs\n        with the project. Alternatively, you may want to cancel the project\n        instead of deleting it.")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": "",
      "loading": _vm.deletingProjectOnly,
      "disabled": _vm.deletingProjectAll || _vm.cancelProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteProject(false)
      }
    }
  }, [_vm._v("Delete project only")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": "",
      "loading": _vm.deletingProjectAll,
      "disabled": _vm.deletingProjectOnly || _vm.cancelProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteProject(true)
      }
    }
  }, [_vm._v("Delete project and jobs")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteProjectDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "750px",
      "scrollable": ""
    },
    model: {
      value: (_vm.changeProductsDialog),
      callback: function($$v) {
        _vm.changeProductsDialog = $$v
      },
      expression: "changeProductsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Change Products")])]), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": !_vm.allProductsMatch,
      "color": "error"
    }
  }, [_vm._v("All of the selected jobs don't currently share the same\n          products.")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "rules": [function (v) { return !!v || 'Item is required'; }],
      "required": "",
      "label": "Select Products",
      "items": _vm.products,
      "multiple": "",
      "chips": "",
      "item-text": "name",
      "item-value": "id",
      "hint": "What products does this job need?",
      "persistent-hint": "",
      "deletable-chips": "",
      "dense": ""
    },
    model: {
      value: (_vm.allSelectedProducts),
      callback: function($$v) {
        _vm.allSelectedProducts = $$v
      },
      expression: "allSelectedProducts"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeProductsDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingSaveJob,
      "disabled": !_vm.allSelectedProducts.length
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveChangedProducts($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.addToProjectDialog),
      callback: function($$v) {
        _vm.addToProjectDialog = $$v
      },
      expression: "addToProjectDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline mr-4"
  }, [_vm._v("Assign Jobs to Project")]), _vm._v(" "), (!_vm.createNewProject) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.createNewProject = true
      }
    }
  }, [_vm._v("create new project?")]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.createNewProject = false
      }
    }
  }, [_vm._v("cancel new project?")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', [(_vm.createNewProject === false) ? _c('v-autocomplete', {
    attrs: {
      "label": "Assign to Project",
      "items": _vm.filteredCustomerProjects,
      "item-text": "projectId",
      "item-value": "projectId"
    },
    model: {
      value: (_vm.assignToProject),
      callback: function($$v) {
        _vm.assignToProject = $$v
      },
      expression: "assignToProject"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createNewProject === true) ? [_c('v-autocomplete', {
    attrs: {
      "label": "Project to copy",
      "items": _vm.projects,
      "item-text": "projectId",
      "item-value": "projectId"
    },
    model: {
      value: (_vm.duplicateProjectSource),
      callback: function($$v) {
        _vm.duplicateProjectSource = $$v
      },
      expression: "duplicateProjectSource"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key"
    },
    model: {
      value: (_vm.duplicateProjectSupplier),
      callback: function($$v) {
        _vm.duplicateProjectSupplier = $$v
      },
      expression: "duplicateProjectSupplier"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.duplicateProjectSource === null
    },
    on: {
      "click": _vm.createDuplicateProject
    }
  }, [_vm._v("Create New Project")])] : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Jobs to be assigned")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n              " + _vm._s(job.JobNo) + "\n            ")])
  }), 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "disabled": _vm.assignToProject === null,
      "loading": _vm.savingAddJobsToProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addJobsToProject($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addToProjectDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.assignToEngineerDialog),
      callback: function($$v) {
        _vm.assignToEngineerDialog = $$v
      },
      expression: "assignToEngineerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Assign Jobs to Engineer")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-autocomplete', {
    attrs: {
      "label": "Assign to Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key",
      "disabled": ""
    },
    model: {
      value: (_vm.assignToSupplier),
      callback: function($$v) {
        _vm.assignToSupplier = $$v
      },
      expression: "assignToSupplier"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Assign to Engineer",
      "items": _vm.assignToSupplierEngineers,
      "item-text": "name",
      "item-value": "key",
      "loading": _vm.gettingEngineers,
      "clearable": "",
      "disabled": !_vm.assignToSupplier
    },
    model: {
      value: (_vm.assignToEngineer),
      callback: function($$v) {
        _vm.assignToEngineer = $$v
      },
      expression: "assignToEngineer"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Jobs to be assigned")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n              " + _vm._s(job.JobNo) + "\n            ")])
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.assignToSupplier) ? _c('h5', {
    staticClass: "error--text"
  }, [_vm._v("\n            A Supplier must be assigned to the selected jobs parent project\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingAssignJobsToEngineer,
      "disabled": !_vm.assignToSupplier
    },
    nativeOn: {
      "click": function($event) {
        return _vm.assignJobsToEngineer($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.assignToEngineerDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.deleteJobsDialog),
      callback: function($$v) {
        _vm.deleteJobsDialog = $$v
      },
      expression: "deleteJobsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Delete Jobs")])]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("You are about to delete these jobs")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n            " + _vm._s(job.JobNo) + "\n          ")])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": "",
      "loading": _vm.deletingJobs
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteMultiJobs($event)
      }
    }
  }, [_vm._v("Delete Jobs")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteJobsDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.approveJobsDialog),
      callback: function($$v) {
        _vm.approveJobsDialog = $$v
      },
      expression: "approveJobsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Approve Jobs")])]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("You are about to approve these jobs")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n            " + _vm._s(job.JobNo) + "\n          ")])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "flat": "",
      "loading": _vm.approvingJobs
    },
    nativeOn: {
      "click": function($event) {
        return _vm.approveMultiJobs($event)
      }
    }
  }, [_vm._v("Approve Jobs")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.approveJobsDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.approveDialog),
      callback: function($$v) {
        _vm.approveDialog = $$v
      },
      expression: "approveDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Approve Job")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Update Vehicle Reg"
    },
    model: {
      value: (_vm.approvalReg),
      callback: function($$v) {
        _vm.approvalReg = $$v
      },
      expression: "approvalReg"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("You are about to approve job " + _vm._s(_vm.currentJobNo) + ".")]), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? [_c('h5', [_vm._v("Job Attachments")]), _vm._v(" "), _vm._l((_vm.jobs.find(function (job) {
    return job.id === this$1.currentJob;
  }).completedDocs), function(doc, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "href": doc.downloadUrl,
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
  })] : _vm._e(), _vm._v(" "), _c('upload-btn', {
    ref: "btnAttachCompletedFile",
    attrs: {
      "uniqueId": "",
      "title": 'Attach New Document',
      "multiple": true,
      "fileChangedCallback": _vm.attachCompletedFile
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-paperclip")])], 1)], 2), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.fileProgress === 100 ? 'success' : 'primary',
      "value": _vm.fileProgress
    }
  })], 2), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "flat": "",
      "loading": _vm.approvingJob,
      "disabled": _vm.jobs.find(function (job) {
          return job.id === this$1.currentJob;
        }).Status < 1 &&
        !_vm.jobs.find(function (job) {
          return job.id === this$1.currentJob;
        }).completedDocs
    },
    nativeOn: {
      "click": function($event) {
        return _vm.approveCurrentJob($event)
      }
    }
  }, [_vm._v("\n          Approve Job\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.approveDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.issueDialog),
      callback: function($$v) {
        _vm.issueDialog = $$v
      },
      expression: "issueDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Flag Issue With Job")])]), _vm._v(" "), _c('v-card-text', [_c('h4', [_vm._v("You are about to flag an issue with job " + _vm._s(_vm.currentJobNo) + ".")]), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Notes"
    },
    model: {
      value: (_vm.JobNotes),
      callback: function($$v) {
        _vm.JobNotes = $$v
      },
      expression: "JobNotes"
    }
  })] : _vm._e()], 2), _vm._v(" "), (
    _vm.jobs.find(function (job) {
      return job.id === this$1.currentJob;
    })
  ) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "flat": "",
      "loading": _vm.issueingJob
    },
    nativeOn: {
      "click": function($event) {
        return _vm.issueCurrentJob($event)
      }
    }
  }, [_vm._v("Issue With Job")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.issueDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.assignInstallDateDialog),
      callback: function($$v) {
        _vm.assignInstallDateDialog = $$v
      },
      expression: "assignInstallDateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Assign Install Date")])]), _vm._v(" "), _c('v-card-text', [_c('v-menu', {
    ref: "assignDateDialog",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "min-width": "290px",
      "return-value.sync": "assignInstallDate",
      "close-on-content-click": false
    },
    model: {
      value: (_vm.assignDateDialog),
      callback: function($$v) {
        _vm.assignDateDialog = $$v
      },
      expression: "assignDateDialog"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Install Date",
      "value": _vm._f("formatDate")(_vm.assignInstallDate),
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.assignDateDialog.save(_vm.assignInstallDate)
      }
    },
    model: {
      value: (_vm.assignInstallDate),
      callback: function($$v) {
        _vm.assignInstallDate = $$v
      },
      expression: "assignInstallDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "flat": "",
      "loading": _vm.assigningDates
    },
    nativeOn: {
      "click": function($event) {
        return _vm.assignInstallDates($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.assignInstallDateDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.bulkUpdateCostDialog),
      callback: function($$v) {
        _vm.bulkUpdateCostDialog = $$v
      },
      expression: "bulkUpdateCostDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Update Cost ")]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "label": "Currency",
      "items": ['£', '€']
    },
    model: {
      value: (_vm.bulkUpdateCurrency),
      callback: function($$v) {
        _vm.bulkUpdateCurrency = $$v
      },
      expression: "bulkUpdateCurrency"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.bulkUpdateCost),
      callback: function($$v) {
        _vm.bulkUpdateCost = $$v
      },
      expression: "bulkUpdateCost"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success darken-1",
      "loading": _vm.updatingCosts,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCosts($event)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.bulkUpdateCostDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-speed-dial', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected.length > 0),
      expression: "selected.length > 0"
    }],
    attrs: {
      "bottom": "",
      "right": "",
      "fixed": "",
      "color": "primary"
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": "",
      "fab": "",
      "hover": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "pink"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        _vm.deleteJobsDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Delete")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "secondary"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.changeProducts
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("mdi-swap-horizontal")])], 1), _vm._v(" "), _c('span', [_vm._v("Change Products")])], 1), _vm._v(" "), (_vm.selected.length === 2) ? _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "light-blue"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "light-blue"
    },
    on: {
      "click": function($event) {
        _vm.mergeJobsDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("mdi-set-center")])], 1), _vm._v(" "), _c('span', [_vm._v("Merge")])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSameProject) ? _c('v-tooltip', {
    attrs: {
      "color": "indigo",
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "indigo"
    },
    on: {
      "click": function($event) {
        _vm.assignToEngineerDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('span', [_vm._v("Assign Engineer")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "red"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.assignInstallDateDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("mdi-calendar")])], 1), _vm._v(" "), _c('span', [_vm._v("Assign Install Date")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "orange"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "orange"
    },
    on: {
      "click": function($event) {
        _vm.addToProjectDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("library_add")])], 1), _vm._v(" "), _c('span', [_vm._v("Change Project")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "green"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        _vm.approveJobsDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve Jobs")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "purple"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "purple"
    },
    on: {
      "click": function($event) {
        _vm.bulkUpdateCostDialog = true
      }
    },
    slot: "activator"
  }, [_vm._v("\n          £\n        ")]), _vm._v(" "), _c('span', [_vm._v("Add Cost")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "yellow"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "yellow"
    },
    on: {
      "click": _vm.printSelectedJobs
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('span', [_vm._v("Print")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d902e4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 749
// module chunks = 1